import { ButtonMenu, ButtonMenuItem } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import styled from 'styled-components'

const CustomCard = styled(ButtonMenu)`
  background-color: transparent;
  border: none;
  button {
    background: none;
  }
`

const CustomButtonMenuItem = styled(ButtonMenuItem)<{ side: string }>`
  border-top-left-radius: ${({ side }) => (side === 'left' ? '10px' : '0px')};
  border-bottom-left-radius: ${({ side }) => (side === 'left' ? '10px' : '0px')};
  border-top-right-radius: ${({ side }) => (side === 'right' ? '10px' : '0px')};
  border-bottom-right-radius: ${({ side }) => (side === 'right' ? '10px' : '0px')};
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.alienPurple : theme.colors.cardBorder)};
  letter-spacing: 0;
`

const HistoryTabMenu = ({ setActiveIndex, activeIndex }) => {
  const { t } = useTranslation()

  return (
    <CustomCard activeIndex={activeIndex} onItemClick={setActiveIndex} scale="sm" variant="subtle">
      <CustomButtonMenuItem side='left'>{t('All history')}</CustomButtonMenuItem>
      <CustomButtonMenuItem side='right'>{t('Your history')}</CustomButtonMenuItem>
    </CustomCard>
  )
}

export default HistoryTabMenu
